import { createContext, useState } from "react";

export const InfraccionesContext = createContext();

export function InfraccionesProvider({ children }) {
    const [form, setForm] = useState({
        agente: "",
        cantidadUMAs: "",
        cantidadDias: "",
        nivelMulta: "media",
        incidencia: "Alta",
        serieEquipo: "20252027",
        fecha: new Date().toISOString().split("T")[0],
        motivo: "",
        articulos: [],
        calle: "",
        entreCalle: "",
        yCalle: "",
        municipio: "IXTAPALUCA",
        colonia: "",
        seRetuvo: [],

        conductorAusente: false,
        sinLicencia: false,
        nombre: "",
        apellidoPaterno: "",
        apellidoMaterno: "",
        rfc: "",
        calleInfractor: "",
        exterior: "",
        interior: "",
        coloniaInfractor: "",
        municipioInfractor: "",
        estadoInfractor: "México",
        codigoPostal: "",
        licencia: "",
        emision: "",
        vigencia: "",
        tipoLicencia: "",

        placas: "",
        serieAuto: "",
        expedidoEn: "México",
        marca: "",
        submarca: "",
        tipoVehiculo: "",
        color: "",
        modelo: "",
        tarjetaCirculacion: "",
        folioInventario: "",
        deposito: "",
    });

    const resetForm = () => {
        setForm({
            agente: "",
            cantidadUMAs: "",
            cantidadDias: "",
            nivelMulta: "media",
            incidencia: "Alta",
            serieEquipo: "20252027",
            fecha: new Date().toISOString().split("T")[0],
            motivo: "",
            articulos: [],
            calle: "",
            entreCalle: "",
            yCalle: "",
            municipio: "IXTAPALUCA",
            colonia: "",
            seRetuvo: [],

            conductorAusente: false,
            sinLicencia: false,
            nombre: "",
            apellidoPaterno: "",
            apellidoMaterno: "",
            rfc: "",
            calleInfractor: "",
            exterior: "",
            interior: "",
            coloniaInfractor: "",
            municipioInfractor: "",
            estadoInfractor: "México",
            codigoPostal: "",
            licencia: "",
            emision: "",
            vigencia: "",
            tipoLicencia: "",

            placas: "",
            serieAuto: "",
            expedidoEn: "México",
            marca: "",
            submarca: "",
            tipoVehiculo: "",
            color: "",
            modelo: "",
            tarjetaCirculacion: "",
            folioInventario: "",
            deposito: "",
        });
    };

    return (
        <InfraccionesContext.Provider value={{ form, setForm, resetForm }}>
            {children}
        </InfraccionesContext.Provider>
    );
}
